import { Component, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucidePlus } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';

@Component({
  selector: 'app-button-add-new',
  imports: [HlmButtonImports, HlmIconImports],
  providers: [provideIcons({ lucidePlus })],
  template: `
    <button hlmBtn variant="zone" size="large" type="button">
      <ng-icon name="lucidePlus" />
      <span>{{ label() }}</span>
    </button>
  `,
})
export class ButtonAddNewComponent {
  readonly label = input.required<string>();
}
